import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { ProtectedRoute } from './routes/ProtectedRoute'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import LandingPage from './pages/LandingPage'
import RCAWizard from './pages/RCAWizard'
import RCAResults from './pages/RCAResults'
import Governance from './pages/Governance'
import ShareView from './pages/ShareView'
import Privacy from './pages/Privacy'
import NotFound from './pages/NotFound'
import ProjectDetail from './pages/ProjectDetail'
import BillingPage from './pages/BillingPage'
import CheckoutSuccess from './pages/CheckoutSuccess'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/share/:token" element={<ShareView />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/billing/success" element={<CheckoutSuccess />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/assess" element={<RCAWizard />} />
          <Route path="/assess/:id" element={<RCAResults />} />
          <Route path="/governance" element={<Governance />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  )
}
